@if (spinner) {
  <div id="spinner-layover">
    <mat-spinner></mat-spinner>
  </div>
}

@if (guestRole && roles) {
  <div class="guest-view">
    <mat-card appearance="outlined" class="guest-form">
      <app-guest-form
        [guest]="guestRole.guest"
        [canEditUserInfo]="editUserInfo"
        [canUpdate]="true"
        (changeEditUserInfoButton)="getButtonChangeEvent($event)"
        [isNewAccount]="false"
      ></app-guest-form>
      <br />
    </mat-card>
    <div class="role-info">
      <mat-card appearance="outlined" class="role-form">
        <app-role-form [guestRole]="guestRole" [roles]="roles" [edit]="true"></app-role-form>
        <mat-card-actions class="action-container">
          <button mat-raised-button color="primary" (click)="saveGuestRoleInfo()">Update role</button>
        </mat-card-actions>
        @if (guestRoleLoading) {
          <app-loading message="Saving changes, please wait...."></app-loading>
        }
      </mat-card>
      <mat-card appearance="outlined" class="role-history">
        <app-role-history [guestRoles]="otherGuestRoles" [roles]="roles"></app-role-history>
      </mat-card>
    </div>
  </div>
}
